import { render, staticRenderFns } from "./DirectDeliveryAdviceEdit.vue?vue&type=template&id=94da69f4&scoped=true"
import script from "./DirectDeliveryAdviceEdit.vue?vue&type=script&lang=js"
export * from "./DirectDeliveryAdviceEdit.vue?vue&type=script&lang=js"
import style0 from "./DirectDeliveryAdviceEdit.vue?vue&type=style&index=0&id=94da69f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94da69f4",
  null
  
)

export default component.exports